import {
  FETCH_LOG,
  FETCH_LOG_SUCCESS,
  FETCH_LOG_ERROR,
  ADD_LOG,
  ADD_LOG_SUCCESS,
  ADD_LOG_ERROR,
} from "constants/ActionTypes";

export const fetchLog = (params) => {
  return {
    type: FETCH_LOG,
    params,
  }
};

export const fetchLogSuccess = (LogList) => {
  return {
    type: FETCH_LOG_SUCCESS,
    payload: LogList,
  }
};

export const fetchLogError = (error) => {
  return {
    type: FETCH_LOG_ERROR,
    payload: error
  }
};

export const addLog = (payload) => {
  return {
    type: ADD_LOG,
    payload,
  }
};

export const addLogSuccess = (payload) => {
  return {
    type: ADD_LOG_SUCCESS,
    payload,
  }
};

export const addLogError = (error) => {
  return {
    type: ADD_LOG_ERROR,
    payload: error
  }
};
